import { jsx as _jsx } from "react/jsx-runtime";
import Landing from '../components/ui/landing/landing';
export var __N_SSG = true;
export function Index(props) {
  return /*#__PURE__*/_jsx(Landing, {
    products: props.products
  });
}

Index.getLayout = function (page) {
  return page;
};

Index.title = 'Articali - Autonomous Publications Hub';
export default Index;